// File automatically generated by `vite-plugin-module-list`
export default [
  {
    path: "components/APIClient.js",
    module: () => import("./components/APIClient.js"),
  },
  {
    path: "components/APIClientData.js",
    module: () => import("./components/APIClientData.js"),
  },
  {
    path: "components/APIClientDeprecatedOauthFlow.js",
    module: () => import("./components/APIClientDeprecatedOauthFlow.js"),
  },
  {
    path: "components/APIClientFlowTypeCell.js",
    module: () => import("./components/APIClientFlowTypeCell.js"),
  },
  {
    path: "components/APIClientList.js",
    module: () => import("./components/APIClientList.js"),
  },
  {
    path: "components/APIClientNameCell.js",
    module: () => import("./components/APIClientNameCell.js"),
  },
  {
    path: "components/AirLinkChatbot.js",
    module: () => import("./components/AirLinkChatbot.js"),
  },
  {
    path: "components/AirLinkChatbotFeedback.js",
    module: () => import("./components/AirLinkChatbotFeedback.js"),
  },
  {
    path: "components/AirLinkChatbotFileAttachment.js",
    module: () => import("./components/AirLinkChatbotFileAttachment.js"),
  },
  {
    path: "components/AirLinkChatbotMarkdown.js",
    module: () => import("./components/AirLinkChatbotMarkdown.js"),
  },
  {
    path: "components/AirLinkChatbotOperationCard.js",
    module: () => import("./components/AirLinkChatbotOperationCard.js"),
  },
  {
    path: "components/AirLinkChatbotPanel.js",
    module: () => import("./components/AirLinkChatbotPanel.js"),
  },
  {
    path: "components/AirLinkChatbotPlanCard.js",
    module: () => import("./components/AirLinkChatbotPlanCard.js"),
  },
  {
    path: "components/AirLinkChatbotTableFigure.js",
    module: () => import("./components/AirLinkChatbotTableFigure.js"),
  },
  {
    path: "components/AirLinkChatbotWidgetCard.js",
    module: () => import("./components/AirLinkChatbotWidgetCard.js"),
  },
  {
    path: "components/AirLinkComboChart.js",
    module: () => import("./components/AirLinkComboChart.js"),
  },
  {
    path: "components/AirLinkHighchart.js",
    module: () => import("./components/AirLinkHighchart.js"),
  },
  {
    path: "components/AirLinkValueChart.js",
    module: () => import("./components/AirLinkValueChart.js"),
  },
  {
    path: "components/AutoRefreshControl.js",
    module: () => import("./components/AutoRefreshControl.js"),
  },
  {
    path: "components/Dashboard.js",
    module: () => import("./components/Dashboard.js"),
  },
  {
    path: "components/DashboardItem.js",
    module: () => import("./components/DashboardItem.js"),
  },
  {
    path: "components/DashboardItemBooleanConfiguration.js",
    module: () => import("./components/DashboardItemBooleanConfiguration.js"),
  },
  {
    path: "components/DashboardItemConfigurationDefault.js",
    module: () => import("./components/DashboardItemConfigurationDefault.js"),
  },
  {
    path: "components/DashboardList.js",
    module: () => import("./components/DashboardList.js"),
  },
  {
    path: "components/DmvpnList.js",
    module: () => import("./components/DmvpnList.js"),
  },
  {
    path: "components/FilterListCompact.js",
    module: () => import("./components/FilterListCompact.js"),
  },
  {
    path: "components/FleetSystemComplianceView.js",
    module: () => import("./components/FleetSystemComplianceView.js"),
  },
  {
    path: "components/Group.js",
    module: () => import("./components/Group.js"),
  },
  {
    path: "components/GroupAccess.js",
    module: () => import("./components/GroupAccess.js"),
  },
  {
    path: "components/GroupAccessData.js",
    module: () => import("./components/GroupAccessData.js"),
  },
  {
    path: "components/GroupAdd.js",
    module: () => import("./components/GroupAdd.js"),
  },
  {
    path: "components/GroupApplyRulesData.js",
    module: () => import("./components/GroupApplyRulesData.js"),
  },
  {
    path: "components/GroupApplyRulesSummary.js",
    module: () => import("./components/GroupApplyRulesSummary.js"),
  },
  {
    path: "components/GroupComplianceRuleCell.js",
    module: () => import("./components/GroupComplianceRuleCell.js"),
  },
  {
    path: "components/GroupComplianceTab.js",
    module: () => import("./components/GroupComplianceTab.js"),
  },
  {
    path: "components/GroupData.js",
    module: () => import("./components/GroupData.js"),
  },
  {
    path: "components/GroupDropdown.js",
    module: () => import("./components/GroupDropdown.js"),
  },
  {
    path: "components/GroupFilterList.js",
    module: () => import("./components/GroupFilterList.js"),
  },
  {
    path: "components/GroupList.js",
    module: () => import("./components/GroupList.js"),
  },
  {
    path: "components/GroupListApplyOperationsCell.js",
    module: () => import("./components/GroupListApplyOperationsCell.js"),
  },
  {
    path: "components/GroupListData.js",
    module: () => import("./components/GroupListData.js"),
  },
  {
    path: "components/GroupListDeviceCell.js",
    module: () => import("./components/GroupListDeviceCell.js"),
  },
  {
    path: "components/GroupListFilterCountCell.js",
    module: () => import("./components/GroupListFilterCountCell.js"),
  },
  {
    path: "components/GroupListFleetStatus.js",
    module: () => import("./components/GroupListFleetStatus.js"),
  },
  {
    path: "components/GroupListNameCell.js",
    module: () => import("./components/GroupListNameCell.js"),
  },
  {
    path: "components/GroupListOperationBadge.js",
    module: () => import("./components/GroupListOperationBadge.js"),
  },
  {
    path: "components/GroupListRuleComplianceCell.js",
    module: () => import("./components/GroupListRuleComplianceCell.js"),
  },
  {
    path: "components/GroupOperationTaskActionCell.js",
    module: () => import("./components/GroupOperationTaskActionCell.js"),
  },
  {
    path: "components/GroupOperationTaskDateCell.js",
    module: () => import("./components/GroupOperationTaskDateCell.js"),
  },
  {
    path: "components/GroupOperationTaskLaunchedByCell.js",
    module: () => import("./components/GroupOperationTaskLaunchedByCell.js"),
  },
  {
    path: "components/GroupOperationTaskNameCell.js",
    module: () => import("./components/GroupOperationTaskNameCell.js"),
  },
  {
    path: "components/GroupOperationTaskStatusCell.js",
    module: () => import("./components/GroupOperationTaskStatusCell.js"),
  },
  {
    path: "components/GroupOperationTaskStatusValue.js",
    module: () => import("./components/GroupOperationTaskStatusValue.js"),
  },
  {
    path: "components/GroupOperationsTab.js",
    module: () => import("./components/GroupOperationsTab.js"),
  },
  {
    path: "components/GroupParent.js",
    module: () => import("./components/GroupParent.js"),
  },
  {
    path: "components/GroupParentFilterList.js",
    module: () => import("./components/GroupParentFilterList.js"),
  },
  {
    path: "components/GroupPath.js",
    module: () => import("./components/GroupPath.js"),
  },
  {
    path: "components/GroupRuleApplySettingsFromFileContent.js",
    module: () =>
      import("./components/GroupRuleApplySettingsFromFileContent.js"),
  },
  {
    path: "components/GroupRuleApplyTemplateContent.js",
    module: () => import("./components/GroupRuleApplyTemplateContent.js"),
  },
  {
    path: "components/GroupRuleDeviceModelCountFlag.js",
    module: () => import("./components/GroupRuleDeviceModelCountFlag.js"),
  },
  {
    path: "components/GroupRuleDeviceModelList.js",
    module: () => import("./components/GroupRuleDeviceModelList.js"),
  },
  {
    path: "components/GroupRuleDeviceModelPanelHeader.js",
    module: () => import("./components/GroupRuleDeviceModelPanelHeader.js"),
  },
  {
    path: "components/GroupRuleEditorContext.js",
    module: () => import("./components/GroupRuleEditorContext.js"),
  },
  {
    path: "components/GroupRuleInstallFirmwareContent.js",
    module: () => import("./components/GroupRuleInstallFirmwareContent.js"),
  },
  {
    path: "components/GroupRuleInstallFirmwareDeviceModelList.js",
    module: () =>
      import("./components/GroupRuleInstallFirmwareDeviceModelList.js"),
  },
  {
    path: "components/GroupRuleList.js",
    module: () => import("./components/GroupRuleList.js"),
  },
  {
    path: "components/GroupRulePanelHeader.js",
    module: () => import("./components/GroupRulePanelHeader.js"),
  },
  {
    path: "components/GroupRulePanelValidationIcon.js",
    module: () => import("./components/GroupRulePanelValidationIcon.js"),
  },
  {
    path: "components/GroupRuleSettingsFileInput.js",
    module: () => import("./components/GroupRuleSettingsFileInput.js"),
  },
  {
    path: "components/GroupRuleTitleIcon.js",
    module: () => import("./components/GroupRuleTitleIcon.js"),
  },
  {
    path: "components/GroupRuleUpdateContext.js",
    module: () => import("./components/GroupRuleUpdateContext.js"),
  },
  {
    path: "components/GroupRuleValidationScope.js",
    module: () => import("./components/GroupRuleValidationScope.js"),
  },
  {
    path: "components/GroupRulesPanelList.js",
    module: () => import("./components/GroupRulesPanelList.js"),
  },
  {
    path: "components/GroupSelector.js",
    module: () => import("./components/GroupSelector.js"),
  },
  {
    path: "components/IMEILockResumeTerminateSIM.js",
    module: () => import("./components/IMEILockResumeTerminateSIM.js"),
  },
  {
    path: "components/IMEILockUnlock.js",
    module: () => import("./components/IMEILockUnlock.js"),
  },
  {
    path: "components/IMEILockUnlockBulk.js",
    module: () => import("./components/IMEILockUnlockBulk.js"),
  },
  {
    path: "components/IMEILockUpdateIMEIAndResumeSIM.js",
    module: () => import("./components/IMEILockUpdateIMEIAndResumeSIM.js"),
  },
  {
    path: "components/LoraDevice.js",
    module: () => import("./components/LoraDevice.js"),
  },
  {
    path: "components/LoraDeviceActivation.js",
    module: () => import("./components/LoraDeviceActivation.js"),
  },
  {
    path: "components/LoraDeviceCreate.js",
    module: () => import("./components/LoraDeviceCreate.js"),
  },
  {
    path: "components/LoraDeviceCredentials.js",
    module: () => import("./components/LoraDeviceCredentials.js"),
  },
  {
    path: "components/LoraDeviceCredentialsGateway.js",
    module: () => import("./components/LoraDeviceCredentialsGateway.js"),
  },
  {
    path: "components/LoraDeviceCredentialsSensor.js",
    module: () => import("./components/LoraDeviceCredentialsSensor.js"),
  },
  {
    path: "components/LoraDeviceModel.js",
    module: () => import("./components/LoraDeviceModel.js"),
  },
  {
    path: "components/LoraDeviceNetworkRegion.js",
    module: () => import("./components/LoraDeviceNetworkRegion.js"),
  },
  {
    path: "components/LoraDeviceSeaasInfo.js",
    module: () => import("./components/LoraDeviceSeaasInfo.js"),
  },
  {
    path: "components/LoraDeviceSeaasInfoNetworkServers.js",
    module: () => import("./components/LoraDeviceSeaasInfoNetworkServers.js"),
  },
  {
    path: "components/LoraDeviceSettings.js",
    module: () => import("./components/LoraDeviceSettings.js"),
  },
  {
    path: "components/LoraDeviceSystemType.js",
    module: () => import("./components/LoraDeviceSystemType.js"),
  },
  {
    path: "components/LoraDeviceUseCase.js",
    module: () => import("./components/LoraDeviceUseCase.js"),
  },
  {
    path: "components/LoraSystemInfoTable.js",
    module: () => import("./components/LoraSystemInfoTable.js"),
  },
  {
    path: "components/Modal.js",
    module: () => import("./components/Modal.js"),
  },
  { path: "components/Name.js", module: () => import("./components/Name.js") },
  {
    path: "components/NotificationCampaignList.js",
    module: () => import("./components/NotificationCampaignList.js"),
  },
  {
    path: "components/NotificationTemplateForm.js",
    module: () => import("./components/NotificationTemplateForm.js"),
  },
  {
    path: "components/NotificationTemplateList.js",
    module: () => import("./components/NotificationTemplateList.js"),
  },
  {
    path: "components/NotificationTemplateListData.js",
    module: () => import("./components/NotificationTemplateListData.js"),
  },
  {
    path: "components/PageContextFilter.js",
    module: () => import("./components/PageContextFilter.js"),
  },
  {
    path: "components/SelectionCountOfTotal.js",
    module: () => import("./components/SelectionCountOfTotal.js"),
  },
  {
    path: "components/SignalStrengthGraphic.js",
    module: () => import("./components/SignalStrengthGraphic.js"),
  },
  {
    path: "components/StyleSheetLoader.js",
    module: () => import("./components/StyleSheetLoader.js"),
  },
  {
    path: "components/SwitchBooleanLogic.js",
    module: () => import("./components/SwitchBooleanLogic.js"),
  },
  {
    path: "components/VpnList.js",
    module: () => import("./components/VpnList.js"),
  },
  {
    path: "components/groupComplianceDisplay.js",
    module: () => import("./components/groupComplianceDisplay.js"),
  },
];
